/**
 * ProgressBar (P143.2) -- a determinate brass progress bar. `value`/`max`
 * drive the fill; the track is calm slate. Carries the WAI-ARIA
 * progressbar role so a screen reader reads the percentage. The fill
 * width transitions smoothly, instant under reduced-motion.
 */
interface ProgressBarProps {
  value: number;
  max: number;
  testid?: string;
}

export function ProgressBar({ value, max, testid }: ProgressBarProps) {
  const pct = max > 0 ? Math.min(100, Math.round((value / max) * 100)) : 0;
  return (
    <div
      data-testid={testid}
      role="progressbar"
      aria-valuenow={value}
      aria-valuemin={0}
      aria-valuemax={max}
      className="h-2 w-full overflow-hidden rounded-full bg-slate-200"
    >
      <div
        className="h-full rounded-full bg-brand-brass transition-[width] duration-500 motion-reduce:transition-none"
        style={{ width: `${pct}%` }}
      />
    </div>
  );
}
